<template>
  <el-row>
    <el-col v-if="this.isManager()" :span="23">
      <el-button icon="fa fa-trash-alt"
      @click="deleteEntry()" size="small" type="danger" circle :disabled="isViewOnly()"></el-button>
    </el-col>
  </el-row>
  </template>

  <script>

  import PostMixins from '@/mixins/PostMixins'

  export default {
    mixins: [PostMixins],

    props: {
      rowData: {
        type: Object,
        required: true
      },

      tableRef: {
        type: String,
        default: 'contactstable'
      }
    },

    methods: {

      deleteEntry () {
        this.deleteItem(this, this.rowData.id, '/contacts', this.rowData.name, this.onDelete)
      },

      onDelete (response) {
        this.$events.fire(this.tableRef + '-refresh-table')
      }

    }
  }
  </script>

  <style>
  .item {
    margin-top: 10px;
    margin-right: 40px;
  }
  </style>



// WEBPACK FOOTER //
// ContactControls.vue?5bb5b150